module.exports = __webpack_public_path__ + "static/bottom-8f47e01deaa4eca8a98a9b131e67894a.png";